module.exports = __webpack_public_path__ + "img/title+.26fd20a3.png";